module.exports = __webpack_public_path__ + "img/guanyu_shouji@2x.8acd0cff.png";